import moment from "moment";
import { DATE_DAY_FORMATE } from "@/libs/constants";
import { contract_broad_types } from "@/libs/conctract_utils.js";
import { AGREEMENT, COURSE_WITHOUT_STOCK, CLOSE } from "./constants";
import { getsafe } from "@/libs/util.js";
const main_type_name_hash = contract_broad_types.hash();
const OPEN = "open";
const EXPENSE = "expense";
export function createEpopAccount() {
  return {
    id: null,
    platform_id: null,
    platform_name: null,
    purpose: null,
    account_name: null,
    account_type: null,
    login_type_id: null,
    login_type_name: null,
    login_username: null,
    login_password: null,
    payment_password: null,
    customer_id: null,
    remark: null,
    virtual: null,
  };
}
export function handleContractAttrs(res) {
  const income_expenses_hash = {};
  const main_type_hash = {};
  const i_e_m_hash = {};
  res.forEach((item) => {
    item = {
      ...item,
      mian_type_name:
        (item.main_type &&
          main_type_name_hash[item.main_type] &&
          main_type_name_hash[item.main_type].title) ||
        "",
    };
    // 合同收支类型纬度
    if (!income_expenses_hash[item.balance_type]) {
      income_expenses_hash[item.balance_type] = [];
    }
    income_expenses_hash[item.balance_type].push(item);
    // 合同大类维度
    if (!main_type_hash[item.main_type]) {
      main_type_hash[item.main_type] = [];
    }
    main_type_hash[item.main_type].push(item);
    // 合同收支类型-合同维度类型
    if (!i_e_m_hash[`${item.balance_type}-${item.main_type}`]) {
      i_e_m_hash[`${item.balance_type}-${item.main_type}`] = [];
    }
    i_e_m_hash[`${item.balance_type}-${item.main_type}`].push(item);
  });
  return {
    income_expenses_hash,
    main_type_hash,
    i_e_m_hash,
  };
}

export function commonValidateRule(text) {
  return (val) => {
    return !["", undefined, null].includes(val) || text;
  };
}

export function isIllegalityValue(val) {
  return ["", null, undefined].includes(val);
}

/*
初始化参数

*/
// 补充信息
export function createContractRechargeParams() {
  return {
    id: null,
    recharge_type: null,
    advertise_type: null,
    advertise_channels: [],
    advertise_account_id: null, // 本期不做
  };
}

// 合同结算款项

export function createContractSettlementsParams() {
  return {
    id: null,
    start_date: null, // 开始时间
    end_date: null, // 结束时间
    settlement_type: null,
    settlement_percentage: null,
    payment_amount: null,
    payment_date: null,
    desc: null,
  };
}

// 发票信息
export function createContractInvoiceParams() {
  return {
    id: null,
    invoice_type: null,
    tax_rate: null,
    tax: null,
    excluding_tax: null,
  };
}

// 关联合同
export function createlinkContractsParams() {
  return {
    id: null,
    uid: null,
  };
}

export function createContractStockWarehouses() {
  return {
    warehouse_id: null,
    qty: null,
    warehouse_name: null,
  };
}
// 存货
export function createStockParams() {
  return {
    id: undefined, // 关联 id
    stock_price_id: null,
    stock_id: null, // 存货 id
    stock_in_type: null, // 入库类型（委外订单）
    qty: null, // 采购数量
    unit_price: null,
    total_price: null,
    estimate_arrival_time: null,
    uid: null, //存货编码 （后端不需要）
    name: null, // 存货名称 （后端不需要）
    barcode: null, // 条码 (后端不需要)
    contract_stock_warehouses: [createContractStockWarehouses()],
  };
}

//  虚拟存货-配件
export function createVirtualStockParams() {
  return {
    id: undefined, // 关联 id
    stock_id: null, // 存货 id
    qty: null, // 采购数量
    unit_price: null,
    total_price: null,
    uid: null, //存货编码 （后端不需要）
    name: null, // 存货名称 （后端不需要）
    barcode: null, // 条码 (后端不需要)
    unit_qty: null, // 配件用量
  };
}

// 投放记录
export function createTfRecordParams() {
  return {
    id: null,
    uid: null,
    estimate_publish_at: null,
    publish_at: null,
    publish_form: null,
    docking_customer_name: null,
    team_id: null,
    sku: null,
    total_price: null,
    paid_price: null,
    consume_price: null,
    vas_amount: null,
    rebate_amount: null,
    bfiles: null,
  };
}

export function createContractProducts() {
  return {
    sub_item_id: null,
    title: null,
    qty: null,
    unit_price: null,
    effective_month: null,
  };
}

export function createContractParams() {
  return {
    _contract_generate_type: "",
    id: null,
    contract_sz_type: null, // 合同收支类型 （后端不需要）
    zhibiao_date: moment().format(DATE_DAY_FORMATE), // 制表时间 （后端不需要）
    fill_user: null, // 制表人 （后端不需要）（后端会返回）
    principal: null, // 负责人 （后弹不需要）（后端会返回）
    uid: null,
    contract_type_bread_id: null, // 合同大类（后端不需要）
    virtual_contract_type: null, //  虚拟合同类型  1、由主合同生成；2、缴纳店铺/账号的保证金或验证款；3、主体经营事项；4、其他（后端不需要）
    show_stock: false, // 展示存货信息（后端不需要）
    is_virtual_stock: false, // 展示虚拟组合存货（后端不需要）
    contract_type: null, // 合同小类的名称（后端不需要）
    contract_type_id: null, // 合同小类
    contract_nature: null, // 合同性质
    apply_user: null,
    apply_user_id: null,
    team_id: null,
    name: null,
    company_id: null,
    is_framework: false, // 是否是框架合同
    multi_payee: null, // 涉及多个供应商
    account_name: null, // 店铺或账号信息   虚拟合同 type 2
    account_id: null, // 店铺或账号信息——id
    payee_company_type: 1, // 供应商类型 (默认公司)
    payee_company_id: null, // 供应商id
    payee_company_account_id: null, // 供应商账号id
    payee_company: null, // 供应商名称/个人姓名
    payee_bank: null, // 开户行
    payee_bank_number: null, // 供应商银行账号
    payee_bank_type: null, // 付款方式
    total_price: null, // 合同总价
    legal_audit_user: null, // 法务审批人
    legal_audit_user_id: null, // 法务审批人 id
    is_recharge: false, // 是否充值预付（充值合同）()
    contract_start: null, // 合同开始日期
    contract_end: null, // 合同结束日期
    desc: null, // 合同备注
    contract_recharge: createContractRechargeParams(),
    contract_settlements: [createContractSettlementsParams()],
    contract_invoices: [createContractInvoiceParams()], // 发票信息
    link_contracts: [createlinkContractsParams()], // 关联合同
    draft_link_contracts: {}, // 关联合同（后端不需要【草稿箱用】）
    bill_type: "Standard", // 订单类型
    contract_stocks: [createStockParams()], // 存货
    contract_stock_parts: [createVirtualStockParams()], // 虚拟组合存货
    need_split_expense: false, // 是否需要拆费用
    bill_generate_type: null, // 账单生成方式
    cost_allocation: false, //
    // ads_record_ids: [createTfRecordParams()], // 投放记录
    // contract_is_finished: false,
    placing_ads_vas_records: [],
    contract_products: [createContractProducts()],
    // consume_schedule: {
    //     id: null,
    //     start_date: null,
    //     end_date: null,
    //     bill_generate_type: null, // 与外层的一样（后端不需要）
    //     need_split_expense: false, // 与外层的一样（后端不需要）
    //     is_consumption_plan: false, // 消耗计划（后端不需要）
    // },
    bfiles: [],
    epop_account: null, // createEpopAccount()
  };
}
const virtual_contract_type_list = [
  {
    text: "由主合同生成",
    val: 1,
  },
  {
    text: "缴纳店铺/账号的保证金或验证款",
    val: 2,
  },
  {
    text: "主体经营事项",
    val: 3,
  },
  {
    text: "其他",
    val: 4,
  },
];
// 获取虚拟合同类型
export function getVirtualContractType(sub_type, is_virtual) {
  if (!is_virtual) {
    return null;
  }
  sub_type = sub_type || "";
  let virtual_contract_type = null;
  for (let i = 0; i < virtual_contract_type_list.length; i++) {
    const item = virtual_contract_type_list[i];
    if (sub_type.includes(item.text)) {
      virtual_contract_type = item.val;
      break;
    }
  }
  return virtual_contract_type;
}

export function handleEditData(params) {
    const base_params = createContractParams()
    const clone_params = {}
    let is_stock = false
    // const is_virtual_stock = false
    // 字段填充
    Object.keys(base_params).forEach(key => {
        switch (key) {
            case 'contract_sz_type':
                clone_params[key] = params.contract_type.balance_type
                break;
            case 'zhibiao_date':
                clone_params[key] = moment(params.created_at).format(DATE_DAY_FORMATE) 
                    break;
            // case 'fill_user':
            //     clone_params[key] = params.fill_user
            //     break;
            case 'contract_type_bread_id':
                clone_params[key] = params.contract_type.main_type
                break
            case 'show_stock':
                clone_params[key] = ['stock_course', 'stock'].includes(params.contract_type.relation_type)
                break
            case 'contract_recharge':
                if (params.contract_recharge) {
                    clone_params.contract_recharge = params.contract_recharge || base_params.contract_recharge
                    Object.keys(base_params.contract_recharge).forEach(key => {
                        clone_params.contract_recharge[key] = clone_params.contract_recharge[key] || base_params.contract_recharge[key]
                    })
                    try {
                        let advertise_channels = params.contract_recharge.advertise_channels && params.contract_recharge.advertise_channels.split(',')
                        advertise_channels = advertise_channels.filter(i => !!i)
                        clone_params.contract_recharge.advertise_channels = advertise_channels
                    } catch (error) {
                        clone_params.contract_recharge.advertise_channels = params.contract_recharge.advertise_channels || []
                    }
                 
                } else {
                    clone_params.contract_recharge = base_params.contract_recharge
                }
                break
            case 'contract_settlements':
                if (params.contract_nature === CLOSE && params.contract_settlements && params.contract_settlements.length) {
                    clone_params.contract_settlements = params.contract_settlements 
                } else {
                    clone_params.contract_settlements = base_params.contract_settlements
                }
                break
            case 'contract_invoices':
             
                if (params.contract_invoices && params.contract_invoices.length) {
                    clone_params.contract_invoices = params.contract_invoices.map(item => {
                        return {
                            ...item,
                            tax_rate:  Number(item.tax_rate)
                        }
                    })
                } else {
                    clone_params.contract_invoices = base_params.contract_invoices
                }
                console.log('params.contract_invoices', clone_params.contract_invoices)
                break
            case 'link_contracts':
                 clone_params.link_contracts = params.link_contracts
                // params.link_contracts
                // if (params.contract_nature === 'frame') {
                //     clone_params.link_contracts = params.link_contracts
                // } else {
                //     clone_params.link_contracts = base_params.link_contracts
                // }
                break
            case 'contract_stocks':
                 is_stock = ['stock_course', 'stock'].includes(params.contract_type.relation_type)
                 clone_params.is_virtual_stock = clone_params.is_virtual_stock || 
                 (params.contract_type && 
                  params.contract_type.sub_type && 
                  params.contract_type.sub_type.includes('虚拟组装订单'))
                if (is_stock || clone_params.is_virtual_stock) {
                    clone_params.contract_stocks = params.contract_stocks && params.contract_stocks.map(item => {
                        const contract_stock_warehouses = item.contract_stock_warehouses && item.contract_stock_warehouses.length ? item.contract_stock_warehouses : [createContractStockWarehouses()]
                        return {
                            uid: item.stock.uid, //存货编码 （后端不需要）
                            name: item.stock.name, // 存货名称 （后端不需要）
                            barcode: item.stock.barcode, // 条码 (后端不需要)
                            ...item,
                            contract_stock_warehouses
                        }
                    }) || [createStockParams()]
                } else {
                    clone_params.contract_stocks = base_params.contract_stocks
                }
                break
            case 'contract_stock_parts':
                clone_params.is_virtual_stock = clone_params.is_virtual_stock || 
                (params.contract_type && 
                 params.contract_type.sub_type && 
                 params.contract_type.sub_type.includes('虚拟组装订单'))
               if (clone_params.is_virtual_stock) {
                   clone_params.contract_stock_parts = params.contract_stock_parts && params.contract_stock_parts.map(item => {
                      //  const contract_stock_warehouses = item.contract_stock_warehouses && item.contract_stock_warehouses.length ? item.contract_stock_warehouses : [createContractStockWarehouses()]
                       return {
                           uid: item.stock.uid, //存货编码 （后端不需要）
                           name: item.stock.name, // 存货名称 （后端不需要）
                           barcode: item.stock.barcode, // 条码 (后端不需要)
                           ...item,
                          //  contract_stock_warehouses
                       }
                   }) || [createVirtualStockParams()]
               } else {
                   clone_params.contract_stock_parts = base_params.createVirtualStockParams
               }
                break
            case 'consume_schedule':
                // clone_params[key] = {
                //     start_date: null,
                //     end_date: null,
                //     bill_generate_type:  params.bill_generate_type, // 与外层的一样（后端不需要）
                //     need_split_expense: params.need_split_expense, // 与外层的一样（后端不需要）
                //     is_consumption_plan: false, // 消耗计划（后端不需要）
                //     ...(params[key] || {})
                // }
                // if (clone_params[key].start_date) {
                //     clone_params[key].is_consumption_plan = true
                // }
                break
            case 'virtual_contract_type':
                clone_params[key] = getVirtualContractType(params.contract_type && params.contract_type.sub_type, (params.contract_type && params.contract_type.main_type === 'virtual' || params.contract_type_bread_id === 'virtual'))
            break
            case 'ads_record_ids':
                clone_params[key] = undefined// params.placing_ads_records
                break
            case 'contract_type':
                clone_params[key] = params.contract_type
                break
            // case 'contract_is_finished':
            //     clone_params[key] = params.user_flow && params.user_flow.is_finish || false
            //     break
          default:
                clone_params[key] = params[key] 
                break;
        }
      
    })
    clone_params.disableEditPrice = false;
    if (params.user_flow && params.user_flow.current_user_flow_node && params.user_flow.current_user_flow_node.status === 3) {
        clone_params.disableEditPrice = true;
    }
    // clone_params.is_recharge = !!params.contract_recharge
    return clone_params
}

export function handleSubmitData(params) {
  // eslint-disable-next-line
  const {
    contract_sz_type,
    zhibiao_date,
    uid,
    date_range,
    fill_user,
    contract_type_bread_id,
    virtual_contract_type,
    _contract_generate_type,
    draft_link_contracts,
    is_virtual_stock,
    principal,
    contract_type,
    show_stock,
    ...other_params
  } = params;
  // 不是充值预付（充值合同），则无补充信息
  if (virtual_contract_type !== 2) {
    delete other_params.account_name;
    delete other_params.account_id;
  }
  if (!other_params.is_recharge) {
    delete other_params.contract_recharge;
  } else {
    other_params.contract_recharge.advertise_channels = other_params.contract_recharge.advertise_channels.join(
      ","
    );
  }

  if (contract_sz_type !== EXPENSE && other_params.contract_nature !== CLOSE) {
    delete other_params.contract_invoices;
  }
  if (other_params.contract_invoices) {
    other_params.contract_invoices = other_params.contract_invoices.filter(
      (i) => !!i.invoice_type
    );
    if (
      other_params.contract_invoices &&
      !other_params.contract_invoices.length
    ) {
      delete other_params.contract_invoices;
    }
  }

  // 如果不是闭口合同，则无合同结算款项和发票信息
  if (other_params.contract_nature !== CLOSE) {
    delete other_params.contract_settlements;
  } else {
    const settlement_type =
      other_params.contract_settlements[0].settlement_type;
    if (settlement_type !== AGREEMENT) {
      // eslint-disable-next-line
      other_params.contract_settlements = other_params.contract_settlements.map(
        ({ settlement_percentage, ...other }) => other
      );
    }
  }
  // 如果不是框架合同，则无关联合同
  // if (other_params.contract_nature !== FRAME) {
  //     delete other_params.link_contracts
  // }

  // 存货合同相关
  if (is_virtual_stock) {
    // eslint-disable-next-line
    other_params.contract_stock_parts = other_params.contract_stock_parts.map(
      ({ uid, name, barcode, _item, ...other_item }) => {
        return other_item;
      }
    );
    // eslint-disable-next-line
    other_params.contract_stocks = other_params.contract_stocks.map(
      ({ uid, name, barcode, _item, ...other_item }) => {
        return other_item;
      }
    );
    other_params.contract_stocks.forEach((item) => {
      item.contract_stock_warehouses = item.contract_stock_warehouses
        .filter((c_item) => c_item.warehouse_id && Number(c_item.qty))
        .map(({ warehouse_id, qty }) => ({
          warehouse_id,
          qty,
        }));
    });
  } else if (show_stock) {
    const is_standard = other_params.bill_type === "Standard";
    // eslint-disable-next-line
    other_params.contract_stocks = other_params.contract_stocks.map(
      ({ uid, name, barcode, _item, ...other_item }) => {
        if (is_standard) {
          delete other_item.stock_in_type;
        }
        return other_item;
      }
    );
    other_params.contract_stocks.forEach((item) => {
      item.contract_stock_warehouses = item.contract_stock_warehouses
        .filter((c_item) => c_item.warehouse_id && Number(c_item.qty))
        .map(({ warehouse_id, qty }) => ({
          warehouse_id,
          qty,
        }));
    });
    delete other_params.contract_stock_parts;
  } else {
    delete other_params.bill_type;
    delete other_params.contract_stocks;
    delete other_params.contract_stock_parts;
  }

  // 财务相关
  // if (other_params.consume_schedule) {
  //     other_params.need_split_expense = other_params.consume_schedule.need_split_expense
  //     other_params.bill_generate_type = other_params.consume_schedule.bill_generate_type
  //     delete other_params.consume_schedule.is_consumption_plan
  //     delete other_params.consume_schedule.need_split_expense
  //     delete other_params.consume_schedule.bill_generate_type
  // }
  other_params.bfiles =
    other_params.bfiles && other_params.bfiles.map((item) => ({ id: item.id }));
  // 投放记录相关
  if (other_params.ads_record_ids && other_params.ads_record_ids.length) {
    //  other_params.ads_record_ids = other_params.ads_record_ids.filter(i => i.id).map(i => i.id)
  } else {
    delete other_params.ads_record_ids;
  }
  // 加成服务不需要提交
  delete other_params.placing_ads_vas_records;
  if (
    !(
      contract_type_bread_id === COURSE_WITHOUT_STOCK &&
      other_params.contract_nature === CLOSE
    )
  ) {
    delete other_params.contract_products;
  }
  return other_params;
}
